import { UrnParams } from './urn.model';

export const URN_DEFAULT_3_COLOR: UrnParams = {
  ballTypes: [
    { id: 'teal', label: 'teal', color: 'teal', pattern: 'hatched', initialCount: 10 },
    { id: 'pink', label: 'pink', color: 'pink', pattern: 'dotted', initialCount: 10 },
    { id: 'purple', label: 'purple', color: 'purple', pattern: 'solid', initialCount: 10 },
  ],
  maxCount: 20,
  initialStatementIndex: 0,
};

export const URN_2_COLOR: UrnParams = {
  ballTypes: [
    { id: 'teal', label: 'teal', color: 'teal', pattern: 'solid', initialCount: 10 },
    { id: 'pink', label: 'pink', color: 'pink', pattern: 'hatched', initialCount: 10 },
  ],
  maxCount: 20,
  initialStatementIndex: 0,
};

export const URN_3_COLOR_WITH_TREE: UrnParams = {
  ballTypes: [
    { id: 'teal', label: 'teal', color: 'teal', pattern: 'hatched', initialCount: 10 },
    { id: 'pink', label: 'pink', color: 'pink', pattern: 'dotted', initialCount: 10 },
    { id: 'purple', label: 'purple', color: 'purple', pattern: 'solid', initialCount: 10 },
  ],
  maxCount: 20,
  initialStatementIndex: 0,
};

export const URN_2_COLOR_WITH_TREE: UrnParams = {
  ballTypes: [
    { id: 'teal', label: 'teal', color: 'teal', pattern: 'solid', initialCount: 10 },
    { id: 'pink', label: 'pink', color: 'pink', pattern: 'hatched', initialCount: 10 },
  ],
  maxCount: 20,
  initialStatementIndex: 0,
};

export const URN_CONDITIONAL_PROBABILITY: UrnParams = {
  ballTypes: [
    { id: 'green', label: 'green', color: 'teal', pattern: 'solid', initialCount: 3 },
    { id: 'red', label: 'red', color: 'pink', pattern: 'solid', initialCount: 2 },
  ],
  maxCount: 20,
  minimal: true,
  initialDrawCount: 2,
  initialWithReplacement: false,
};

export const URN_PRESETS: Record<string, Record<string, unknown>> = {
  'default-3-color': { params: URN_DEFAULT_3_COLOR },
  '2-color': { params: URN_2_COLOR },
  '3-color-with-tree': { params: URN_3_COLOR_WITH_TREE },
  '2-color-with-tree': { params: URN_2_COLOR_WITH_TREE },
  'conditional-probability': { params: URN_CONDITIONAL_PROBABILITY },
};
